module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic12.fc6f1ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic12.png
// module id = 579
// module chunks = 1